import { render, staticRenderFns } from "./GalleryCard.vue?vue&type=template&id=82c96892&"
import script from "./GalleryCard.vue?vue&type=script&lang=js&"
export * from "./GalleryCard.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VFadeTransition,VHover,VIcon,VImg,VOverlay})
